import posthog from "posthog-js";
import { isImpersonating } from "@/services/auth";

export const isLocalDev =
  window.location.hostname === "localhost" ||
  window.location.hostname.endsWith(".localhost") ||
  window.location.hostname === "127.0.0.1";

if (!isLocalDev && !isImpersonating()) {
  posthog.init("phc_mjbHNZZQIpsRJIEhaAQbPfgACMa3f8RF66HEKgHd6jF", {
    api_host: "https://n.getaltimate.com",
    persistence: "memory",
    autocapture: {
      dom_event_allowlist: ["click", "submit"],
      element_allowlist: ["button", "a", "form", "input", "select"],
    },
    capture_pageview: "history_change",
    capture_pageleave: true,
  });
}

export default posthog;
